import { useState } from "react";
import styled from "@emotion/styled";

import SidebarLogout from "./sidebar/SidebarLogout";
import SidebarDarkmode from "./sidebar/SidebarDarkmode";
import SidebarList from "./sidebar/SidebarList";
import ToggleButton from "./sidebar/ToggleButton";

import logo from "../assets/sidebar-logo.png";

const SidebarInner = styled.div`
  position: sticky;
  top: 0;
  flex-shrink: 0;
  height: 100vh;
  background: #232a3b;
  min-width: 280px;
  display: flex;
  flex-direction: column;
`;

const TopGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex: 1;
  min-height: 0;
`;

const LogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  height: 88px;
  overflow: hidden;
  padding-top: 10px;

  & > img {
    width: 180px;
    height: auto;
    object-fit: cover;
    object-position: top center;
  }
`;

const Sidebar = () => {
  const [show, showSet] = useState(true);

  return (
    <>
      {show && (
        <SidebarInner>
          <TopGroup>
            <LogoWrapper>
              <img src={logo} alt="datastems" />
            </LogoWrapper>
            <SidebarLogout />
            <SidebarList />
          </TopGroup>
          <SidebarDarkmode />
        </SidebarInner>
      )}
      <ToggleButton onClick={() => showSet((old) => !old)} />
    </>
  );
};

export default Sidebar;
